// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__17sQZ","Loader-1":"Loader_Loader-1__37IW_","Loader-2":"Loader_Loader-2__KIp6l"};